export default function PoliticaPrivacidadPage() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8 md:p-10">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Política de Privacidad</h1>
          <p className="text-sm text-gray-500 mb-8">Última actualización: 12 de mayo de 2026</p>

          <section className="space-y-4 mb-8">
            <h2 className="text-xl font-semibold">1. Responsable del tratamiento</h2>
            <p className="text-sm leading-6 text-gray-700">
              MaximumStudio (en adelante, la “Aplicación”) es responsable del tratamiento de los datos personales
              utilizados para operar el servicio de gestión y seguimiento deportivo.
            </p>
            <p className="text-sm leading-6 text-gray-700">
              Contacto de privacidad: <a className="text-teal-700 hover:underline" href="mailto:soporte@maximumstudio.cl">soporte@maximumstudio.cl</a>
            </p>
          </section>

          <section className="space-y-4 mb-8">
            <h2 className="text-xl font-semibold">2. Datos que recopilamos</h2>
            <ul className="list-disc pl-6 text-sm leading-6 text-gray-700 space-y-1">
              <li>Identificación y contacto: nombre, correo electrónico, teléfono y WhatsApp (si se informa).</li>
              <li>Datos de cuenta: credenciales de acceso y registro de autenticación.</li>
              <li>Datos deportivos: reservas, rutinas, progreso y métricas asociadas al entrenamiento.</li>
              <li>Datos técnicos: información básica del dispositivo y registros de uso para seguridad y soporte.</li>
              <li>Notificaciones push: token del dispositivo para envío de avisos y recordatorios.</li>
            </ul>
          </section>

          <section className="space-y-4 mb-8">
            <h2 className="text-xl font-semibold">3. Finalidad del uso de datos</h2>
            <ul className="list-disc pl-6 text-sm leading-6 text-gray-700 space-y-1">
              <li>Permitir acceso seguro a la cuenta.</li>
              <li>Gestionar reservas, asistencia, membresías y sesiones.</li>
              <li>Mostrar progreso y contenidos personalizados de entrenamiento.</li>
              <li>Enviar notificaciones operativas o informativas definidas por el gimnasio.</li>
              <li>Prevenir fraude, auditar acciones y mantener la estabilidad del servicio.</li>
            </ul>
          </section>

          <section className="space-y-4 mb-8">
            <h2 className="text-xl font-semibold">4. Conservación de datos (retención)</h2>
            <p className="text-sm leading-6 text-gray-700">
              Conservamos los datos mientras la cuenta esté activa y durante el tiempo necesario para cumplir fines
              operativos, contractuales, legales y de seguridad.
            </p>
            <ul className="list-disc pl-6 text-sm leading-6 text-gray-700 space-y-1">
              <li>Datos de cuenta activa: durante toda la vigencia del servicio.</li>
              <li>Reservas, pagos y trazabilidad operativa: hasta 24 meses desde la última actividad, salvo exigencia legal mayor.</li>
              <li>Registros técnicos y seguridad: hasta 12 meses.</li>
            </ul>
          </section>

          <section className="space-y-4 mb-8">
            <h2 className="text-xl font-semibold">5. Eliminación de datos</h2>
            <p className="text-sm leading-6 text-gray-700">
              El titular puede solicitar la eliminación de su cuenta y datos personales escribiendo a{' '}
              <a className="text-teal-700 hover:underline" href="mailto:soporte@maximumstudio.cl">soporte@maximumstudio.cl</a>.
            </p>
            <ul className="list-disc pl-6 text-sm leading-6 text-gray-700 space-y-1">
              <li>Plazo de respuesta: hasta 10 días hábiles.</li>
              <li>Una vez validada la solicitud, eliminamos o anonimizamos datos personales en un plazo máximo de 30 días.</li>
            </ul>
          </section>

          <section className="space-y-4 mb-8">
            <h2 className="text-xl font-semibold">6. Compartición y encargados</h2>
            <p className="text-sm leading-6 text-gray-700">
              No vendemos datos personales. Podemos utilizar proveedores tecnológicos para operar el servicio
              (hosting, autenticación, mensajería, analítica y notificaciones), bajo obligaciones de confidencialidad y seguridad.
            </p>
          </section>

          <section className="space-y-4 mb-8">
            <h2 className="text-xl font-semibold">7. Seguridad</h2>
            <p className="text-sm leading-6 text-gray-700">
              Aplicamos medidas técnicas y organizativas razonables para proteger los datos contra acceso no autorizado,
              alteración, divulgación o pérdida.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">8. Cambios a esta política</h2>
            <p className="text-sm leading-6 text-gray-700">
              Esta política puede actualizarse. Publicaremos cualquier cambio en esta misma URL con su fecha de actualización.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
